import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Typography,
} from "@suraasa/placebo-ui"
import clsx from "clsx"
import { ReactNode, useState } from "react"

export type FAQType = {
  question: string
  answer: ReactNode | string
}

const FrequentlyAskedQuestion = ({ FAQs }: { FAQs: FAQType[] }) => {
  const [singleExpand, setSingleExpanded] = useState<string>("item-1")

  const toggleSingleExpanded = (item: string) => {
    setSingleExpanded(item)
  }

  return (
    <Accordion
      type="single"
      defaultValue={singleExpand}
      onValueChange={toggleSingleExpanded}
    >
      {FAQs.map((faq, index) => (
        <AccordionItem
          key={index}
          className={clsx("rounded-xl hover:bg-gray-50", {
            "my-1 bg-gray-50": singleExpand === `item-${index + 1}`,
          })}
          value={`item-${index + 1}`}
        >
          <AccordionTrigger
            className={clsx(
              "[&>div]:rounded-lg [&>div]:bg-[#0F131B08] [&>div]:p-1.25",
              singleExpand === `item-${index + 1}` ? "px-3 pb-2 pt-3" : "p-3"
            )}
          >
            <Typography className="w-[79%] text-strong">
              {faq.question}
            </Typography>
          </AccordionTrigger>
          <AccordionContent className="w-[95%] p-3 pt-0 text-smallBody text-muted sm:w-[90%]">
            {faq.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}

export default FrequentlyAskedQuestion
